export const KeyConstructor = (key) => {
    return (options) => {
        const { variables, fields } = options || {};
        return [key, { ...(fields && { fields }), ...(variables && { variables }) }];
    };
};
//# sourceMappingURL=keyConstructor.js.map